import Button from "@mui/material/Button";
import { Component, ReactNode } from "react";

export interface SubmitProps {
    children : ReactNode
    onSubmit: () => void
}

class Submit extends Component<SubmitProps> {

    handleSubmit = (e: React.FormEvent<HTMLButtonElement>) => {
        e.preventDefault()
        this.props.onSubmit()
    }

    render() {
        return (
            <div>
                <Button
                    variant="contained"
                    onClick={this.handleSubmit}
                    style={{ color: "white" }}
                    color="secondary"
                    type="submit"
                >
                    Connexion
                </Button>
            </div>
        )
    }
}

export default Submit